<div class="flex flex-none p-24 flex-row justify-between align-center">
  <div class="h2">Notifications</div>

  <fc-button
    variant="text"
    (click)="notificationsStore.markAllAsRead()"
    class="ml-auto"
    color="primary"
    size="md"
  >
    Mark all as read
  </fc-button>
  <div class="actions">
    <fc-button variant="icon" (click)="closePopup.emit()" icon="icon-close" />
  </div>
</div>

<div class="flex flex-col flex-1 min-h-0 overflow-hidden">
  <fc-tab-group fc-fill-height (selectedTabChange)="onTabChange($event)">
    <fc-tab label="All">
      <fc-event-list />
    </fc-tab>
    <fc-tab label="Event">
      <fc-event-list />
    </fc-tab>
    <fc-tab label="Chat">
      <fc-event-list />
    </fc-tab>
  </fc-tab-group>
</div>
